<template>
  <div>
    <ODialog ref="dialog">
      <v-card>
        <ODialogBar title="Data do relatório" @close="dismiss" />

        <v-card-text class="px-6 pt-6 pb-0">
          <v-expansion-panels v-model="copiedValue.typeIdx" accordion mandatory>
            <v-expansion-panel :key="0">
              <v-expansion-panel-header>Por mês</v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-date-picker
                  no-title
                  scrollable
                  class="elevation-0"
                  full-width
                  type="month"
                  :month-format="getMonthName"
                  v-model="copiedValue.strMonth"
                />
                <p class="caption">
                  Cada Centro de Custo terá o seu início/fim calculado com base
                  na sua Data de Referência e no mês selecionado acima.
                </p>
              </v-expansion-panel-content>
            </v-expansion-panel>
            <v-expansion-panel :key="1">
              <v-expansion-panel-header>Por período</v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-date-picker
                  no-title
                  scrollable
                  full-width
                  show-adjacent-months
                  v-model="copiedValue.range"
                  range
                />
                <p class="caption">
                  Selecione <b>DUAS</b> datas. Este período vai se aplicar a
                  todos os Centros de Custo selecionados.
                </p>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-card-text>

        <ODialogButtons
          class="pa-6"
          txtApply="OK"
          @cancel="dismiss"
          @apply="apply"
        />
      </v-card>
    </ODialog>

    <!-- NB: BasePicker só emite input qdo clica no clear -->
    <BasePicker
      label="Data"
      icon="mdi-calendar"
      :orientation="orientation"
      whenEmpty="(Este mês)"
      :value="strValue"
      @input="clear"
      @open="openDialog"
    />
  </div>
</template>

<script>
import BasePicker from 'oderon-vue/cpts/pickers/BasePicker.vue'
import moment from 'moment'
import { brDateOnly } from 'oderon-commons/src/formatters'

export default {
  components: {
    BasePicker
  },
  props: {
    orientation: { type: String, default: 'horizontal' },

    // Para este picker, o value é um objeto da seguinte forma:
    // {
    //   type: 'month' ou 'range' (se null, 'month')
    //   fromDate: Date
    //   untilDate: Date
    //   strMonth: String (só o moment().format('MMM'))
    // }
    //
    // Se type=month, fromDate e untilDate são null, e o default de
    // strMonth é o mês corrente (para poder destacar no picker).
    // Se type=range, strMonth é null e o default do fromDate/untilDate
    // é null (o picker vai ficar vazio e a api vai usar um default
    // adequado)
    value: {}
  },
  data() {
    return {
      copiedValue: { typeIdx: 0, range: [] }
    }
  },
  computed: {
    strValue() {
      if (this.value == null) {
        // vai aparecer "Este mês" no picker
        return null
      } else if (this.value.type == 'range') {
        // Ambos fromDate e untilDate devem estar setados
        let fd = brDateOnly(this.value.fromDate)
        let ud = brDateOnly(this.value.untilDate)
        return `${fd} a ${ud}`
      } else {
        return moment(this.value.strMonth || undefined).format('MMMM [de] YYYY')
      }
    }
  },
  methods: {
    clear() {
      this.$emit('input', null)
    },

    // Função de formatação que recebe o mês selecionado
    // (e.g. "2023-04") e retorna o texto do botão do mês ("Abr")
    getMonthName(s) {
      return moment(s).format('MMM')
    },

    async openDialog() {
      this.copiedValue = {
        typeIdx: this.value && this.value.type == 'range' ? 1 : 0,
        strMonth: this.value && this.value.strMonth
      }

      if (this.value && this.value.fromDate) {
        this.$set(this.copiedValue, 'range', [
          this.value.fromDate,
          this.value.untilDate || new Date()
        ])
      }

      let res = await this.$refs.dialog.$open()
      if (res != null) {
        this.$emit('input', res)
      }
    },

    dismiss() {
      this.$refs.dialog.$dismiss()
    },

    apply() {
      let newValue = null
      if (this.copiedValue.typeIdx == 1) {
        let today = moment().format('YYYY-MM-DD')
        let a = moment(this.copiedValue.range[0], 'YYYY-MM-DD')
        let b = moment(this.copiedValue.range[1] || today, 'YYYY-MM-DD')
        let fromDate = moment.min(a, b).format('YYYY-MM-DD')
        let untilDate = moment.max(a, b).format('YYYY-MM-DD')

        newValue = {
          type: 'range',
          fromDate,
          untilDate,
          strMonth: null
        }
      } else {
        newValue = {
          type: 'month',
          fromDate: null,
          untilDate: null,
          strMonth: this.copiedValue.strMonth
        }
      }
      this.$refs.dialog.$apply(newValue)
    }
  }
}
</script>

<style></style>
